<template>
	<div ref="container" class="pb-5">
		<template v-if="smsSent">
			<ConfirmMobilePhone
				:user="user"
				:job-profile="jobProfile"
				@resend="save(true)"
				@change="changeData"
				@finish="$emit('finish', $event)"
			/>
		</template>
		<template v-else-if="checkData">
			<CheckData
				:user="user"
			/>
			<div class="mt-3 text-right">
				<b-form-checkbox v-model="checkDataOk">Die Daten stimmen</b-form-checkbox>
			</div>
		</template>
		<template v-else>
			<h3>Geheimhaltung und Datenschutz für dich und Jobsuchende hat Vorrang!</h3>
			<p>Bitte um Bestätigung:</p>
			<div class="mt-4">
				<FormGroup :state="user.secrecyPersonalData === true" invalid-feedback="Bitte ankreuzen"
						   feedback-beneath>
					<b-form-checkbox
						v-model="user.secrecyPersonalData"
						:disabled="secrecyValid"
						@input="secrecyChanged"
					>
						Ich werde persönlichen Daten, die ich von Personen erhalte (Namen, Geburtsdatum, Mobilnummer,
						E-Mail Adresse, Arbeitgeber, Adresse usw.) nicht ohne Zustimmung der betroffenen Personen
						weitergeben oder anderen zugänglich machen.
					</b-form-checkbox>
				</FormGroup>
			</div>
			<div v-if="secrecyValid" class="mt-4">
				<h3>Persönliche Daten</h3>
				<b-row>
					<b-col md="4">
						<FormGroup
							:state="userSalutationValid"
							invalid-feedback="Bitte triff eine Auswahl"
							feedback-beneath
						>
							<SalutationSelect v-model="user.salutation"/>
						</FormGroup>
					</b-col>
					<b-col md="4" class="mt-2 mt-md-0">
						<FormGroup
							:state="userFirstNameValid"
							invalid-feedback="Bitte gib deinen Vornamen ein"
							feedback-beneath
						>
							<b-input v-model="user.firstName" placeholder="Vorname"/>
						</FormGroup>
					</b-col>
					<b-col md="4" class="mt-2 mt-md-0">
						<FormGroup
							:state="userLastNameValid"
							invalid-feedback="Bitte gib deinen Nachnamen ein"
							feedback-beneath
						>
							<b-input v-model="user.lastName" placeholder="Nachname"/>
						</FormGroup>
					</b-col>
				</b-row>
				<div class="mt-1 font-weight-extra-bold color-primary">
					<span class="">Achtung:</span> Vor- und Nachname können später nicht mehr geändert werden.
				</div>
				<div class="mt-4">
					<h3>Mobilnummer - wir senden dir einen Bestätigungscode zu</h3>
					<Phone v-model="user.phone" :meta="meta"/>
				</div>
				<div class="mt-4">
					Nur skilldoo erhält deine Daten zur internen Prüfung und gibt sie ohne deine Zustimmung nicht
					weiter!<br/>
					Deine persönlichen Daten werden somit nur für Personen sichtbar, denen du sie später freigibst.
				</div>
				<div class="mt-4">
					<span class="font-weight-extra-bold">Kostenfrei:</span>
					für die Eintragung des Jobprofils, Suche und Nutzung der grundlegenden Funktionen entstehen keine
					Kosten und keine Vorauszahlungen.
					<br/>
					<span class="font-weight-extra-bold">Kosten</span> entstehen erst, wenn du bestimmte
					Zusatzfunktionen nützen willst oder Kontaktanfragen senden oder entgegennehmen willst. Bei der
					Nutzung wirst du gesondert darauf hingewiesen, bevor Kosten entstehen.
				</div>
			</div>
		</template>
		<div v-if="!smsSent" class="mt-4 text-right">
			<template v-if="checkData">
				<Button
					v-if="!saving"
					text="Daten ändern"
					secondary
					class="mr-3 mb-3 mb-md-0"
					icon="edit"
					@click="changeData"
				/>
			</template>
			<Button
				:text="checkData ? 'Bestätigen / SMS-Code anfordern' : 'Weiter'"
				icon="checkmark"
				:loading="saving"
				:disabled="!dataValid || saving"
				@click="save(false)"
			/>
		</div>
	</div>
</template>

<script>
import FormGroup from "@/vue/common/form/Group.vue"
import {isEmptyOrNull} from "@/helper/String";
import {isDefined} from "@/helper/Value";
import SalutationSelect from "@/vue/common/form/SalutationSelect";
import Phone from "@/vue/common/form/Phone";
import {mapState} from "vuex";
import Button from "@/vue/common/Button.vue";
import * as Log from "@/helper/Log";
import Save from "@/api/job-profile/questionnaire/legitimation/Save";
import CheckData from "@/vue/customer-area/job-profile/questionnaire/CheckData.vue";
import ConfirmMobilePhone from "@/vue/customer-area/job-profile/questionnaire/ConfirmMobilePhone.vue";
import * as Event from "@/helper/tracking/Event";
import EventData from "@/helper/tracking/EventData";

const INITIAL_USER = {
	secrecyPersonalData: false,
	salutation: null,
	firstName: '',
	lastName: '',
	phone: null,
};

export default {

	props: {
		jobProfile: {
			type: Object,
			required: true,
		},
	},

	components: {
		Button,
		FormGroup,
		ConfirmMobilePhone,
		CheckData,
		SalutationSelect,
		Phone,
	},

	mounted ()
	{
		if (this.customer)
		{
			this.user.firstName = this.customer.firstName;
		}
	},

	data ()
	{
		return {
			user: INITIAL_USER,
			checkData: false,
			checkDataOk: false,
			smsSent: false,
			saving: false,
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		...mapState('auth', ['customer']),
		secrecyValid ()
		{
			return this.user.secrecyPersonalData;
		},
		userSalutationValid ()
		{
			return !isEmptyOrNull(this.user.salutation);
		},
		userFirstNameValid ()
		{
			return !isEmptyOrNull(this.user.firstName);
		},
		userLastNameValid ()
		{
			return !isEmptyOrNull(this.user.lastName);
		},
		userPhoneValid ()
		{
			return isDefined(this.user.phone);
		},
		checkDataValid ()
		{
			return !this.checkData || this.checkDataOk;
		},
		dataValid ()
		{
			return this.secrecyValid
				&& this.userSalutationValid
				&& this.userFirstNameValid
				&& this.userLastNameValid
				&& this.userPhoneValid
				&& this.checkDataValid;
		}
	},

	methods: {
		changeData ()
		{
			this.smsSent = false;
			this.checkData = false;
			this.checkDataOk = false;

			this.$emit('changeData');
		},
		secrecyChanged ()
		{
			this.$nextTick(() =>
			{
				if (this.secrecyValid)
				{
					this.$emit('scrollIntoView');
				}
			});
		},
		async save (again)
		{
			if (!this.dataValid)
			{
				return;
			}

			if (!this.checkData && !again)
			{
				this.checkData = true;

				this.$emit('checkData');

				return;
			}

			Event.push(
				new EventData()
					.setEvent(Event.QUESTIONNAIRE)
					.setAction('Legitimierung')
			);

			this.saving = true;

			try
			{
				await new Save()
					.setJobProfileId(this.jobProfile.id)
					.setSalutation(this.user.salutation)
					.setFirstName(this.user.firstName)
					.setLastName(this.user.lastName)
					.setPhone(this.user.phone)
					.call();

				this.checkData = false;
				this.checkDataOk = false;
				this.smsSent = true;

				this.$emit('confirmMobilePhone');
			}
			catch (e)
			{
				Log.error(e);
			}

			this.saving = false;
		}
	},
}
</script>
